
import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import { useLocation } from 'react-router-dom';
import './Navbar.css'; // Import the CSS file

const Navbar: React.FC = () => {

    const navItems = [
        { name: 'Home', path: '/' },
        { name: 'About', path: '/about' },
        { name: 'Services', path: '/services' },
        { name: 'Contact', path: '/contact-section' },
    ];

    const [isOpen, setIsOpen] = useState(false);

    // Hide navbar on scroll down, reveal on scroll up
    const [hidden, setHidden] = useState(false);
    const lastScrollY = useRef(0);

    useEffect(() => {
        // The page's actual scroll position isn't reliably on window.scrollY in
        // this app (html/body end up as their own scroll container in some
        // setups), so read from whichever element actually has scrollTop set.
        const getScrollY = () =>
            window.scrollY
            || document.documentElement.scrollTop
            || document.body.scrollTop
            || 0;

        lastScrollY.current = getScrollY();
        let ticking = false;

        const updateNavbar = () => {
            const currentScrollY = getScrollY();

            if (currentScrollY < 80) {
                // Always show near the top of the page
                setHidden(false);
            } else if (currentScrollY > lastScrollY.current) {
                setHidden(true); // scrolling down
            } else if (currentScrollY < lastScrollY.current) {
                setHidden(false); // scrolling up
            }

            lastScrollY.current = currentScrollY;
            ticking = false;
        };

        const handleScroll = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(updateNavbar);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        document.addEventListener('scroll', handleScroll, { passive: true, capture: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('scroll', handleScroll, { capture: true });
        };
    }, []);

    //PRODUCTS DROPDOWN
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
    // Optional: Close dropdown when a link is clicked
    const closeDropdown = () => setIsDropdownOpen(false);
    
    //ROADMAP DROPDOWN
    const [isDropdown2Open, setIsDropdown2Open] = useState(false);
    const toggleDropdown2 = () => setIsDropdown2Open(!isDropdown2Open);
    // Optional: Close dropdown when a link is clicked
    const closeDropdown2 = () => setIsDropdown2Open(false);

    return (
        <nav
            className="navbar"
            style={{
                transform: hidden && !isOpen ? 'translateY(-100%)' : 'translateY(0)',
                transition: 'transform 0.35s ease',
            }}
        >
            <div>
                <NavLink className="navbar-brand"  to="/"> 
                    AquaWARE
                </NavLink>
            </div>
            <button className="navbar-toggle" onClick={() => setIsOpen(!isOpen)}>
                ☰
            </button>
            <div className={`navbar-links ${isOpen ? 'active' : ''}`}>
                <ul>
                    <li key={'Home'}>
                        <NavLink
                            to="/" 
                            className={({ isActive }) => isActive ? 'navbar-link active-link' : 'navbar-link'}
                            onClick={() => setIsOpen(false)} // Close menu on link click
                            >
                            Home
                        </NavLink>
                    </li>
                    <li key={'About'}>
                        <NavHashLink
                            smooth
                            to="/#about-section"
                            className={'navbar-link'}
                            onClick={() => setIsOpen(false)} // Close menu on link click
                        >
                            About
                        </NavHashLink>
                    </li>
                    <li key={'Services'}>
                        <NavHashLink
                            smooth
                            to={"/#services-section"}
                            className={'navbar-link'}
                            onClick={() => setIsOpen(false)} // Close menu on link click
                        >
                            Services
                        </NavHashLink>
                    </li>
                    <li key={'Contact'}>
                        <NavHashLink
                            smooth
                            to="/#contact-section"
                            className={'navbar-link'}
                            onClick={() => setIsOpen(false)} // Close menu on link click
                        >
                            Contact
                        </NavHashLink>
                    </li>
                    <li className="navbar-vertical-separator"> </li> {/* Separator */}
                    <li key={'Media'}>
                        <NavLink
                            to="/media"
                            className={({ isActive }) => isActive ? 'navbar-link active-link' : 'navbar-link'}
                            onClick={() => setIsOpen(false)} // Close menu on link click
                        >
                            Media
                        </NavLink>
                    </li>
                    <li key={'Releases'}>
                        <NavLink
                            to="/releases"
                            className={({ isActive }) => isActive ? 'navbar-link active-link' : 'navbar-link'}
                            onClick={() => setIsOpen(false)} // Close menu on link click
                        >
                            Releases
                        </NavLink>
                    </li>
                    <li key={'Products'}
                        className="dropdown"
                        onMouseEnter={toggleDropdown} // Use mouse events for hover
                        onMouseLeave={toggleDropdown}
                    >
                        <NavLink 
                            className={({ isActive }) => isActive ? 'navbar-link active-link' : 'navbar-link'}
                            to="/products"
                            onClick={() => setIsOpen(false)} // Close menu on link click
                            >
                            Products
                        </NavLink>
                        {isDropdownOpen && (
                            <div className="dropdown-content">
                                {/* Use Link for navigation within the dropdown */}
                                <NavHashLink to="/products/#detail-integrity" onClick={closeDropdown}>AquaWARE - integrity</NavHashLink>
                                <NavHashLink to="/products/#detail-cloud" onClick={closeDropdown}>AquaWARE - bank</NavHashLink>
                                <NavHashLink to="/products/#detail-simula" onClick={closeDropdown}>AquaWARE - simula</NavHashLink>
                                <NavHashLink to="/products/#detail-phone" onClick={closeDropdown}>AquaWARE - sync</NavHashLink>
                                <NavHashLink to="/products/#detail-dev" onClick={closeDropdown}>AquaCARE - R&D</NavHashLink>
                                <NavHashLink to="/products/#detail-reports" onClick={closeDropdown}>AquaCARE - SaaS</NavHashLink>
                                <NavHashLink to="/products/#detail-integrity2" onClick={closeDropdown}>AquaCARE - Data Integration</NavHashLink>
                                <NavHashLink to="/products/#detail-control-center" onClick={closeDropdown}>AquaCARE - Control Center</NavHashLink>
                            </div>
                        )}
                    </li>
                    {/* <li key={'Roadmap'}
                        className="dropdown"
                        onMouseEnter={toggleDropdown2}
                        onMouseLeave={toggleDropdown2}
                    >
                        <NavLink
                            className={({ isActive }) => isActive ? 'navbar-link active-link' : 'navbar-link'}
                            to="/roadmap"
                            onClick={() => setIsOpen(false)}
                        >
                            Roadmap
                        </NavLink>
                        {isDropdown2Open && (
                            <div className="dropdown-content">
                                <NavHashLink to="/roadmap/#current" onClick={closeDropdown2}>Current</NavHashLink>
                                <NavHashLink to="/roadmap/#shortterm" onClick={closeDropdown2}>Short Term</NavHashLink>
                                <NavHashLink to="/roadmap/#mediumterm" onClick={closeDropdown2}>Medium Term</NavHashLink>
                                <NavHashLink to="/roadmap/#longterm" onClick={closeDropdown2}>Long Term</NavHashLink>
                            </div>
                        )}
                    </li> */}
                    <li key={'Clients'}>
                        <NavLink
                            className={({ isActive }) => isActive ? 'navbar-link active-link' : 'navbar-link'}
                            to="/clients"
                            onClick={() => setIsOpen(false)}
                        >
                            Clients
                        </NavLink>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;